import PropTypes from 'prop-types';
import {useTheme} from 'react-jss';
import {connect} from 'react-redux';
import Button from '../../../UI/Button/Button';
import Field2 from '../../form/Field2';
import FieldLabel from '../../form/FieldLabel';
import LabelWrapper from '../../form/FieldWrapper/LabelWrapper/LabelWrapper';
import Validation from '../../form/Validation';
import ValidationMessage from '../../form/ValidationMessage/ValidationMessage';
import Translation from '../../lang/Translation';
import {isMobile} from '../../selectors/DeviceSelectors';
import isUsingArtemisStyles from '../../selectors/isUsingArtemisStyles';
import {getSiteDataV2} from '../../selectors/selectors';
import Width from '../../style-helper/Width';
import useStyles from './PostcodeAnywhereInput.styles';
import selectUseStyles from '../../form/SelectField.styles';

export const VALIDATE_THAT_OTHER_FIELDS_ARE_SHOWN = 'PostcodeAnywhereInput.VALIDATE_THAT_OTHER_FIELDS_ARE_SHOWN';

export function PostcodeAnywhereInput(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  const selectFieldClasses = selectUseStyles({...props, theme, width: Width.full});
  
  const validateThatOtherFieldsAreShown = () => {
    if (!props.disabled && props.value && !props.isShowOtherFields) {
      props.postcodeAnywhere.find();
      return 'errors.formFields.pcaError';
    }
  };
  
  const findButton = () => (
    <div data-test="PostcodeAnywhereInput__buttonContainer" className={classes.buttonContainer}>
      <Button
        id={`pcaButton${props.postcodeAnywhere.embedCode}`}
        name={`pcaButton${props.postcodeAnywhere.embedCode}`}
        onClick={props.postcodeAnywhere.find}
        primary
        data-test="PostcodeAnywhereInput__findAddressButton"
        className={classes.findAddressButton}
        fullWidth
      >
        <Translation>address.findAddress</Translation>
      </Button>
    </div>
  );
  
  const pcaContainer = () => (
    <div key="c" data-test="pca-container" className={classes.pcaContainer}>
      <div id={`pcaDiv${props.postcodeAnywhere.embedCode}`} style={{display: 'none'}}>
        <label
          className={classes.selectAddressLabel}
          htmlFor={`pcaSelect${props.postcodeAnywhere.embedCode}`}
          data-test="Label"
        >
          {' '}
          <Translation>address.selectAddress</Translation>
        </label>
        <select
          className={selectFieldClasses.selectField}
          data-test="PostcodeAnywhereInput__select"
          id={`pcaSelect${props.postcodeAnywhere.embedCode}`}
          onChange={props.postcodeAnywhere.doSelect}
          name={`pcaSelect${props.postcodeAnywhere.embedCode}`}
        />
      </div>
      <Validation
        fieldContainer={props.fieldContainer}
        name={VALIDATE_THAT_OTHER_FIELDS_ARE_SHOWN}
        validate={validateThatOtherFieldsAreShown}
      />
    </div>
  );
  
  const enterAddressManuallyLink = () => {
    if (props.isShowOtherFields) {
      return null;
    }
    return (
      <div key="b">
        <Button
          link
          fullWidth
          onClick={props.clickEnterManuallyLink}
          id="enter-address-manually-link"
          className="enter-address-manually"
        >
          <Translation>address.enterAddressManually</Translation>
        </Button>
      </div>
    );
  };
  
  const handleKeyPress = (event, validate) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      validate(event);
      props.postcodeAnywhere.find();
    }
  };
  
  return (
    <Field2
      disabled={props.disabled}
      fieldContainer={props.fieldContainer}
      definedField={props.definedField}
      value={props.value}
      onBlur={props.updateDeliveryOptions}
      nameOnForm={props.legacyNames.nameOnForm}
    >
      {(onChange, onBlur, onFocus, errorText) => (
        <div className={`field ${props.legacyNames.wrappedClassName}`}>
          <LabelWrapper>
            <FieldLabel
              htmlFor={props.legacyNames.id}
              label={props.definedField.label}
              required={props.definedField.required}
              value={props.value || ''}
              maxLength={props.definedField.maxLength}
            />
          </LabelWrapper>
          <div className="m-unit-main pca-2" id="pca-2" name="pca-2">
            <input
              disabled={props.disabled}
              onChange={onChange}
              onBlur={onBlur}
              onFocus={onFocus}
              value={props.value || ''}
              id={props.legacyNames.id}
              type="text"
              name={props.legacyNames.nameOnForm}
              className={`${props.legacyNames.nameInClass} ${classes.pcaInput} ${errorText ? 'error-block-v2' : ''}`}
              placeholder={props.definedField.hint ? Translation.getText(`address.hint.${props.definedField.hint}`) : undefined}
              onKeyPress={event => handleKeyPress(event, onBlur)}
              autoComplete={props.addressType === 'billing' && props.siteCode === 'nyr' && !props.isMobile ? 'new-password' : 'on'}
            />
            {findButton()}
            {pcaContainer()}
            {errorText ? <ValidationMessage errorText={errorText} /> : ''}
            {enterAddressManuallyLink()}
          </div>
        </div>
      )}
    </Field2>
  );
}

const mapStateToProps = (state) => {
  const siteDataV2 = getSiteDataV2(state);
  
  return {
    siteCode: siteDataV2.siteCode,
    isMobile: isMobile(state),
    isUsingArtemisStyles: isUsingArtemisStyles(state),
  };
};

PostcodeAnywhereInput.propTypes = {
  addressType: PropTypes.oneOf(['delivery', 'billing']).isRequired,
  clickEnterManuallyLink: PropTypes.func.isRequired,
  updateDeliveryOptions: PropTypes.func.isRequired,
  definedField: PropTypes.object.isRequired,
  fieldContainer: PropTypes.object.isRequired,
  fieldNamePrefix: PropTypes.string.isRequired,
  postcodeAnywhere: PropTypes.object.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  isUsingArtemisStyles: PropTypes.bool,
  
  isShowOtherFields: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default connect(
  mapStateToProps,
)(PostcodeAnywhereInput);
